import React from 'react';
import classNames from 'classnames';
import styles from './ContainerSiderbar.module.scss';

interface ContainerProps extends React.HTMLProps<HTMLDivElement> {
  side?: 'left' | 'right';
  width?: 'medium' | 'large';
  nopadding?: boolean;
  borderLeft?: boolean;
}

export const ContainerSiderbar = (props: ContainerProps) => {
  const {
    children,
    nopadding,
    className,
    side = 'right',
    width = 'medium',
    borderLeft,
    ...rest
  } = props;

  const containerClass = classNames(
    styles.container,
    styles[`on-the-${side}`],
    styles[`width-${width}`],
    { [styles.nopadding]: nopadding, [styles['border-left']]: borderLeft },
    className
  );
  return (
    <div {...rest} className={containerClass}>
      {children}
    </div>
  );
};
ContainerSiderbar.defaultProps = {};
